import { isPortfolioItemExtended } from 'utils/portfolio';
import { PcwStep } from './types';
import { PortfolioItemExtended } from 'types/portfolios';
import mappedItemTypes from 'services/items/mappedItemTypes';
import { PCW_STEPS } from './constants';

export const portfolioTypeStepNavigation = (): PcwStep => {
    return 'portfolio-basics';
};

export const ancillariesStepNavigation = (_: any, formData: any): PcwStep => {
    // If the user has selected either Batteries, Thermal item or a Hydro Project item, navigate to ancillaries
    const hydroData = formData?.[PCW_STEPS.PCW_HYDRO_STEP_ID]?.selected;
    if (Array.isArray(hydroData) && hydroData.length > 0) {
        const hasHydroProjectData = hydroData.some(
            (item: any) => isPortfolioItemExtended(item) && item.typeId === mappedItemTypes.HYDRO_PROJECT.id
        );
        if (hasHydroProjectData) {
            return 'add-ancillaries';
        }
    }

    const assetData = formData?.[PCW_STEPS.PCW_ADD_ASSETS_STEP_ID]?.selected;
    if (Array.isArray(assetData) && assetData.length > 0) {
        const hasThermalOrBattery = assetData.some(
            (item: PortfolioItemExtended) =>
                isPortfolioItemExtended(item) &&
                (item.typeId === mappedItemTypes.BATTERY_STORAGE.id ||
                    item.typeId === mappedItemTypes.GENERATION_ASSET.id)
        );
        if (hasThermalOrBattery) {
            return 'add-ancillaries';
        }
    }

    return 'add-hedges-contracts';
};
